export const reusableComponentTableColumns: any = [
  {
    key: "checkbox",
    display_name: "",
    headerStyles: {
      background: "#7593F2",
      width: "5%",
    },
    _config: {
      type: "checkbox-conditional",
      displayInColumn: false,
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
  },
    {
      key: 'expand',
      showExpand: true,
      headerStyles: {
        background: "#7593F2",
        width: '30px'
      }
    },
    {
      display_name: "Reusable Component",
      key: "name",
      hideForChildren: true,
      headerStyles: {
        background: "#7593F2",
        color: '#FFFFFF'
      }
    },
    {
      display_name: "Input/Output",
      key: "inputOutput",
      headerStyles: {
        background: "#7593F2",
        color: '#FFFFFF'
      },
      _config: {
        type: 'lozenge',
        classMapping: {
          "Input": "input-class",
          "Output": "output-class"
        }
      }
    },
    {
      display_name: "Parameter name",
      key: "paramName",
      headerStyles: {
        background: "#7593F2",
        color: '#FFFFFF'
      }
    },
    {
      display_name: "Parameter Type",
      key: "paramType",
      headerStyles: {
        background: "#7593F2",
        width: '15%',
        color: '#FFFFFF'
      }
    },
    {
      display_name: "",
      key: "map",
      _config: {
        type: 'conditional-button',
        name: 'Open',
        isImage: true,
        imgSrc: "../../../../assets/images/table/table-item-open.svg",
        classNames: 'btn-accello-light open-btn ',
        isConditionalCheck: true,
        conditionalCheck : { key: "level", value: 0 },
      },
      headerStyles: {
        background: "#7593F2",
        width: '15%'
      }
    },
    {
      key: "edit",
      display_name: "",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        color: "#FFFFFF",
        width: "4%",
      },
      _config: {
        type: "conditional-svg",
        value: "../../../../assets/images/table/table-item-edit.svg",
        classNames: "btn-accello-light",
        isConditionalCheck: true,
        conditionalCheck: { key: "level", value: 0 },
        isClickable: "true",
      },
    },
  ];